import { render, staticRenderFns } from "./SendPhotoModal.vue?vue&type=template&id=72020a94&scoped=true"
import script from "./SendPhotoModal.vue?vue&type=script&lang=js"
export * from "./SendPhotoModal.vue?vue&type=script&lang=js"
import style0 from "./SendPhotoModal.vue?vue&type=style&index=0&id=72020a94&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72020a94",
  null
  
)

export default component.exports